import { useEffect } from 'react';
import { SegmentWindow } from './types';
import { getProductId } from '~/components/context';

export type UrlParameters = {
  [key: string]: string;
};

export const useAnalyticsListener = (): void => {
  const productId = getProductId();
  const win: SegmentWindow = window;

  useEffect(() => {
    const properties = { productId };
    win.analytics.page({ properties });
  }, [productId]);
};
